import {
  OrderDirection,
  commonMutationTypes,
  pageInfo,
} from "../../../../../../utils/commonQueryTypes";
import { AtsAcLdgr } from "../../supplier/queries/types";

export interface AddProjectExtResult {
  AddProjectExt: {
    id: number;
  };
}

export interface CreateAtsAcLdgrProjectExt {
  name: string;
  projectScope: string;
  contractSignedWith: string;
  loa: string;
  agreementDate: string;
  startDate: string;
  endDate: string;
  agreementFile: string;
  endAgreementFile: string;
}

export interface AddProjectExtVar extends commonMutationTypes {
  customerID: number;
  ldgrID: number;
  projectID: number;
  input: CreateAtsAcLdgrProjectExt;
}

export interface UpdateAtsAcLdgrProjectExt extends CreateAtsAcLdgrProjectExt {
  ldgrID: number;
}

export interface UpdateProjectExtVar extends commonMutationTypes {
  customerID: number;
  projectExtID: number;
  input: UpdateAtsAcLdgrProjectExt;
}

export interface UpdateProjectExtResult {
  UpdateProjectExt: {
    id: number;
  };
}

export interface AtsAcLdgrProjectExt {
  id: number;
  name: string;
  contractValue: number;
  projectScope: string;
  workOrderNum: string;
  contractSignedWith: string;
  loa: string;
  agreementDate: string;
  startDate: string;
  endDate: string;
  insuranceStartDate: string;
  insuranceEndDate: string;
  goLiveDate: string;
  amcStartDate: string;
  amcScope: string;
  amcInsuranceStartDate: string;
  amcInsuranceEndDate: string;
  dlpStartDate: string;
  dlpEndDate: string;
  bgValue: number;
  bgStartDate: string;
  bgEndDate: string;
  slaBillingCycle: string;
  agreementFile: string;
  endAgreementFile: string;
  customerID: number;
  ldgrID: number;
  supplierName: AtsAcLdgr;
}

export interface AtsAcLdgrProjectExtEdge {
  node: AtsAcLdgrProjectExt;
  cursor: string;
}

export interface AtsAcLdgrProjectExtConnection {
  edges: AtsAcLdgrProjectExtEdge[];
  pageInfo: pageInfo;
  totalCount: number;
}

export interface GetProjectExtsResult {
  GetProjectExts: AtsAcLdgrProjectExtConnection;
}

export enum AtsAcLdgrProjectExtOrderField {
  CREATED_AT = "CREATED_AT",
}

export interface AtsAcLdgrProjectExtOrder {
  direction: OrderDirection;
  field: AtsAcLdgrProjectExtOrderField;
}

export interface GetProjectExtsVar {
  token?: string;
  customerID: number;
  empID: number;
  projectID: number;
  after: string | null;
  first: number;
  orderBy: AtsAcLdgrProjectExtOrder;
  name: string;
}

export interface DeleteProjectExtResult {
  DeleteProjectExt: boolean;
}

export interface DeleteProjectExtVar extends commonMutationTypes {
  customerID: number;
  projectExtID: number;
}
